import styles from './profile.module.css'
import Avatar from '@mui/material/Avatar'

export const PlannerProfile = ({ data }) => {
	return (
		<>
			<div className={styles.topProfileInfo}>
				<div>
					<h1>{data.businessName}</h1>
					<Avatar
						src={data.profilePic}
						sx={{ width: '10rem', height: '10rem' }}
					/>
					<h2>
						{data.firstName} {data.lastName}
					</h2>
				</div>
				<div>
					<p>Address: {data.businessAddress}</p>
					<p>Phone number: {data.phone}</p>
				</div>
			</div>
			<p>Links: </p>
			<p>Description: </p>
		</>
	)
}
